module.exports = __webpack_public_path__ + "img/mail_p.c1a8f146.svg";